import { Label, List } from '@mairistem/composants';

const RegiePieceJointeListItem = (props) => {
  const { titre, nomFichier, extensionFichier } = props;

  return (
    <>
      <List.Description>
        <Label content={titre} style={{ fontWeight: 'bold' }} />
      </List.Description>
      <List.Description>
        <Label content={`${nomFichier}.${extensionFichier}`} />
      </List.Description>
    </>
  );
};

export default RegiePieceJointeListItem;
